import { connect } from 'react-redux'
import Head from 'next/head'
import { PrivateRoute } from 'components/PrivateRoute'
import { Sidebar, MainContent, BottomNavbar } from 'components/pages/live'
import config from 'config'
import { useRouter } from "next/router"
import { useTranslation } from 'next-i18next'
import nextI18NextConfig from '../../i18n'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const Live = () => {
  const { t } = useTranslation('live')
  const router = useRouter()

  return (
    <div className='live-container'>
      <Head>
        <title>Connectmingle | Live</title>
        {/* SEO page */}
        <meta name='description' content={t('description')} />
        <meta property='og:url' content={ config.URL + router.route } />
        <meta property='og:title' content='Connectmingle | Live' />
        <meta property='og:image' content={ config.URL + '/images/logo.png' } />
        <meta property='og:description' content={t('description')} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Connectmingle" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content='Connectmingle | Live' />
        <meta name="twitter:description" content={t('description')} />
        <meta name="twitter:image" content={ config.URL + '/images/logo.png' } />
        <meta name="twitter:url" content={ config.URL + router.route } />
        <meta name="robots" content="noindex" />
        {/* <script src="https://js.pusher.com/beams/1.0/push-notifications-cdn.js"></script> */}
      </Head>
      <Sidebar />
      <MainContent />
      {/* <BottomNavbar /> */}
    </div>
  )
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale , ['common'], nextI18NextConfig))
  }
})

const mapStateToProps = (state) => ({
  isLogged: state.connectionReducer.isLogged,
  user: state.connectionReducer.user,
  accessToken: state.connectionReducer.accessToken,
})

export default connect(mapStateToProps)(PrivateRoute(Live))
